import React, {useState} from 'reactn';
import {DeleteOutlined, EditOutlined,} from '@ant-design/icons';
import { Popover, notification, Button, Modal, Input, message, Form, Typography , Checkbox, Select, Radio } from 'antd';

import { useFirestore } from 'reactfire';

const SingleShowMedicine = (props) => {
    const { Title } = Typography;
    const { Option } = Select;

    const [popup, setPopup] = useState(false);
    const [isModalVisible, setModalVisible] = useState(false);
    const [state, setState] = useState({
        medicine: props.medicine.medicine,
        frequency: props.medicine.frequency,
        duration: props.medicine.duration,
        dosage: props.medicine.dosage,
        dosage_in_ml: props.medicine.dosage_in_ml,        
        when: props.medicine.when,
        note: props.medicine.note
    });
    const [loadingBtn, setLoadingBtn] = useState(false);

    const firestore = useFirestore();
    const query = firestore.collection("Treatment_records").doc(props.id);

    const deleteteItrem = () => {
        query.delete().then(() => {
            console.log('Successfully Deleted');
            props.deletedRecord();
            notification.open({
                message: 'Record Deleted',
                icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
        })
        // console.log('deleting' , props.id)
    }
    // const getValue = e => {
    //     setState({note: e.target.value});
    // }

    const onSubmitEditNote = valform => {
        valform.medicine = state.medicine;
        setLoadingBtn(true);
        Object.keys(valform).forEach(key => valform[key] === undefined && delete valform[key]);
        query.update({['medicine_info']: valform}).then(() => {
            message.success('Medicine info updated');
            setModalVisible(false);
            props.deletedRecord();
            setLoadingBtn(false);
        });
    }

    const showDosageVal = ()=> {
        if (state.medicine) {
            if (state.medicine.type === "Drop") {
                return (
                    <>
                    <Option value="ایک قطرے">ایک قطرے</Option>
                    <Option value="دو قطرے">دو قطرے</Option>
                    <Option value="تین قطرے">تین قطرے</Option>
                    <Option value="چار قطرے">چار قطرے</Option>
                    <Option value="پانچ قطرے">پانچ قطرے</Option>
                    </>
                );
            } else if (state.medicine.type === "Tablet") {
                return (
                    <>
                    <Option value="آدھی گولی">آدھی گولی</Option>
                    <Option value="ایک گولی">ایک گولی</Option>
                    <Option value="دو گولیاں">دو گولیاں</Option>
                    <Option value="تین گولیاں">تین گولیاں</Option>
                    <Option value="چار گولیاں">چار گولیاں</Option>
                    <Option value="پانچ گولیاں">پانچ گولیاں</Option>
                    </>
                );
            } else if (state.medicine.type === "capsule") {
                return (
                    <>
                    <Option value="ایک کیپسول">ایک کیپسول</Option>
                    <Option value="دو کیپسول">دو کیپسول</Option>
                    <Option value="تین کیپسول">تین کیپسول</Option>
                    <Option value="چار کیپسول">چار کیپسول</Option>
                    <Option value="پانچ کیپسول">پانچ کیپسول</Option>
                    </>
                );
            } else if (state.medicine.type === "Syrup") {
                return (
                    <>
                    <Option value="آدھا چاۓ کا چمچ">آدھا چاۓ کا چمچ</Option>
                    <Option value="ایک چاۓ کا چمچ">ایک چاۓ کا چمچ</Option>
                    <Option value="ڈیڑھ چاۓ کا چمچ">ڈیڑھ چاۓ کا چمچ</Option>
                    <Option value="دو چاۓ کے چمچ">دو چاۓ کے چمچ</Option>
                    <Option value="تین چاۓ کے چمچ">تین چاۓ کے چمچ</Option>
                    <Option value="چار چاۓ کے چمچ">چار چاۓ کے چمچ</Option>
                    <Option value="پانچ چاۓ کے چمچ">پانچ چاۓ کے چمچ</Option>
                    </>
                );
            } else if (state.medicine.type === "Injection") {
                return (
                    <>
                    <Option value="ایک ٹیکے">ایک ٹیکے</Option>
                    <Option value="دو ٹیکے">دو ٹیکے</Option>
                    <Option value="تین ٹیکے">تین ٹیکے</Option>
                    <Option value="چار ٹیکے">چار ٹیکے</Option>
                    <Option value="پانچ ٹیکے">پانچ ٹیکے</Option>
                    </>
                );
            } else if (state.medicine.type === "Tube") {
                return (
                    <>
                    <Option value="ایک بار">ایک بار</Option>
                    <Option value="دو بار">دو بار</Option>
                    <Option value="تین بار">تین بار</Option>
                    <Option value="چار بار">چار بار</Option>
                    <Option value="پانچ بار">پانچ بار</Option>
                    </>
                );
            } else if (state.medicine.type === "Spray") {
                return (
                    <>
                    <Option value="ایک بار">ایک بار</Option>
                    <Option value="دو بار">دو بار</Option>
                    <Option value="تین بار">تین بار</Option>
                    <Option value="چار بار">چار بار</Option>
                    <Option value="پانچ بار">پانچ بار</Option>
                    </>
                );
            } else {
                return (
                    <>
                    <Option value="ایک خوراک">ایک خوراک</Option>
                    <Option value="دو خوراک">دو خوراک</Option>
                    <Option value="تین خوراک">تین خوراک</Option>
                    <Option value="چار خوراک">چار خوراک</Option>
                    <Option value="پانچ خوراک">پانچ خوراک</Option>
                    </>
                ); 
            }
        }
        
    
    }


    return (
        <>
        {state && <li>
            <h4>{`${state.medicine && state.medicine.medicine_name} (${state.medicine && state.medicine.formula})  - ${state.medicine && state.medicine.weight} - ${state.medicine && state.medicine.type}`}</h4>
            <ul className='medicShow'>
                {state.frequency && <li>Frequency: <strong>{state.frequency.join(",")}</strong></li>}
                {state.dosage && <li>Dosage: <strong>{state.dosage}</strong></li>}
                {state.dosage_in_ml && <li>Dosage: <strong>{state.dosage_in_ml} ml</strong></li>}
                {state.duration && <li>Duration: <strong>{state.duration}</strong></li>}
                {state.when && <li>When: <strong>{state.when}</strong></li>}
            </ul>
            <p>Note: {state.note}</p>
            <Popover
                content={<a onClick={deleteteItrem}>Delete</a>}
                title="Are you sure you want to delete?"
                trigger="click"
                visible={popup}
                onVisibleChange={() => setPopup(!popup) }
            >
                <DeleteOutlined />
            </Popover>
            <EditOutlined style={{cursor: 'pointer'}} onClick={() => setModalVisible(true)} />
        </li>}


        <Modal title="Edit medicine information" width='500px' footer={null} visible={isModalVisible} onCancel={() => setModalVisible(false)}>
            <Form
                name="editmedicine"
                onFinish={onSubmitEditNote}
                initialValues={{
                    ['note']: state.note,
                    ['frequency']: state.frequency,
                    ['dosage']: state.dosage,
                    ['dosage_in_ml']: state.dosage_in_ml,
                    ['duration']: state.duration,
                    ['when']: state.when,
                }}
            >
                <Form.Item
                    label="Frequency"
                    name="frequency">
                    <Checkbox.Group className='img_btns' style={{ width: '100%' }}>
                        <Checkbox value="صبح">صبح</Checkbox>
                        <Checkbox value="دوپہر">دوپہر</Checkbox>
                        <Checkbox value="شام">شام</Checkbox>
                        <Checkbox value="رات">رات</Checkbox>
                        <Checkbox value="حسب ضرورت">حسب ضرورت</Checkbox>
                    </Checkbox.Group>
                </Form.Item>

                <Form.Item
                    label="Dosage"
                    name="dosage"
                >
                    <Select placeholder= "منتخب کریں" >
                                {showDosageVal()}
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Dosage in ml"
                    name="dosage_in_ml"
                    rules={[{ message: 'Please add Medicine Dosage in ml' }]}
                >
                    <Input size="medium" addonAfter="ml" />
                </Form.Item>
                <Form.Item
                    label="Duration"
                    name="duration"
                >
                    <Select defaultValue="ایک دن" >
                        <Option value="ایک دن">ایک دن</Option>
                        <Option value="دو دن">دو دن</Option>
                        <Option value="تین دن">تین دن</Option>
                        <Option value="چار دن">چار دن</Option>
                        <Option value="پانچ دن">پانچ دن</Option>
                        <Option value="چھ دن">چھ دن</Option>
                        <Option value="ایک ہفتہ">ایک ہفتہ</Option>
                        <Option value="دو ہفتے">دو ہفتے</Option>
                        <Option value="تین ہفتے">تین ہفتے</Option>
                        <Option value="ایک مہینہ">ایک مہینہ</Option>
                        <Option value="دو ماہ">دو ماہ</Option>
                        <Option value="جاری رکھیں">جاری رکھیں</Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    label="When to take"
                    name="when">
                    <Radio.Group className='img_btns' buttonStyle="solid" size="large">
                        <Radio.Button value={'کھانے سے پہلے'}>کھانے سے پہلے</Radio.Button>
                        <Radio.Button value={'کھانے کے دوران'}>کھانے کے دوران</Radio.Button>
                        <Radio.Button value={'کھانے کے بعد'}>کھانے کے بعد</Radio.Button>
                    </Radio.Group>
                </Form.Item>

                <Form.Item
                    label="Note"
                    name="note"
                >
                    <Input size="large" />
                </Form.Item>
                
                <Button type="primary" loading={loadingBtn} htmlType="submit">Update</Button>
             </Form>
        </Modal>
        </>
    );
}

export default SingleShowMedicine;
